import {persistReducer} from "redux-persist";
import storage from "redux-persist/lib/storage"

export const actionTypes = {
    CreateTicket: "[Create Ticket] Action"
};

const InitialPlayState = {
    lastCreatedTicket: undefined
};

export const reducer = persistReducer(
    {
        storage,
        key: "ticket",
        whitelist: ["lastCreatedTicket"],
    },
    (state = InitialPlayState, action) => {
        switch (action.type) {
            case actionTypes.CreateTicket : {
                const {lastCreatedTicket} = action.payload;
                return {
                    ...state,
                    lastCreatedTicket
                }
            }
            default:
                return  state;
        }
    }
);

export const actions = {
    createTicket: (lastCreatedTicket) => ({
        type: actionTypes.CreateTicket,
        payload: {lastCreatedTicket}
    })
}